<!-- 线性图表 -->
<template>
  <div class="echarts">
    <div :ref="echartName" style="height:100%;"></div>
  </div>
</template>

<script>
import * as echarts from "echarts";
export default {
  name: 'LineChart',
  components: {},
  props: {
    echartData: {
      type: Object,
      default() {
        return null
      }
    },
    echartName: {
      type: String,
      default: "echarts"
    }
  },
  data() {
    return {
      chartOptions: {
        legend: {
          data: [],
          icon: "circle",
          right: 10,
          top: 10
        },
        grid: {
          left: "3%",
          right: "1%",
          bottom: "3%",
          containLabel: true
        },
        tooltip: {
          trigger: "axis",
          formatter: function (params) {
            console.log(params)
            // 定义一个条件，这里假设条件是 params 数组长度大于 1 且存在带有 percent 属性的数据
            var dataType = params.length > 1 && params[0].data.dataType;
            // dataType 1 会议分析  2 学习监督
            console.log(dataType)
            if (dataType === 1) {
              // 显示自定义内容
              var str = params[0].name + '<br>';
              for (let item of params) {
                str += item.seriesName + ' : ' + item.value;
                if (item.data.time) {
                  str += '<br>' + `${item.seriesName.substr(0, 3)}时间:` + item.data.time.substr(0, 10) + '<br>';
                } else {
                  str += '<br>';
                }
              }
              return str;
            } else if (dataType === 2) {
              // 显示自定义内容
              var str = params[0].name + '<br>';
              for (let item of params) {
                str += item.seriesName + ' : ' + item.value;
                if (item.data.passRate) {
                  str += '<br>' + `合格率:` + item.data.passRate + '<br>';
                } else if(item.data.dutyTeacher){
                  str += '<br>' + `值班老师:` + item.data.dutyTeacher + '<br>';
                }else{
                  str += '<br>'
                }
              }
              return str;
            }else {
              // 显示默认内容
              // 显示默认内容
              let defaultStr = params[0].name + '<br>';
              params.forEach(item => {
                defaultStr += `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:${item.color};"></span>`;
                defaultStr += item.seriesName + ': ' + item.value + '<br>';
              });
              return defaultStr;
            }
          }
        },
        // tooltip: {
        //   trigger: "axis",
        //   formatter: function (params) {
        //     var str = params[0].name + '<br>'
        //     for (let item of params) {
        //       str += item.seriesName + ' : ' + item.value
        //       if (item.data.percent != -1) {
        //         str += '(' + item.data.percent + '%)<br>'
        //       }else{
        //         str += '<br>'
        //       }
        //     }
        //     return str;
        //   }
        // },
        xAxis: {
          type: "category",
          data: [],
          axisTick: {
            show: false // 不显示刻度线
          },
          axisLine: {
            show: false  //不显示坐标轴线
          },
        },
        yAxis: {
          type: "value",
          axisTick: {
            show: false // 不显示刻度线
          },
          splitLine: {  // 去掉网格线
            // show: false,
            lineStyle: {
              type: 'dashed', // 设置虚线类型
              color: '#5A5A89'
            }
          },
          axisLine: { // 控制轴线样式
            show: false,  //不显示坐标轴线
            lineStyle: {
              color: '#5A5A89' // 设置横坐标轴线的颜色
            }
          },
          axisLabel: { // 控制轴标签样式
            // show: this.isLine,
            textStyle: {
              color: '#5A5A89' // 设置横坐标轴标签文字颜色
            },
            formatter: '{value}'
          },
          axisPointer: {
            snap: true
          }
        },
        series: []
      },
      echarts: null,
      a: 'ge'
    }
  },
  created() {
  },
  mounted() {

    this.calcEcharts()
  },
  methods: {
    calcEcharts() {
      if (!this.echarts) {
        this.echarts = echarts.init(this.$refs[this.echartName]);
        // 添加窗口改变监听
        this.echarts._resize = () => {
          this.echarts.resize();
        };
        window.addEventListener("resize", this.echarts._resize);
      }
      this.chartOptions.legend.data = this.echartData.yAxisData.map(it => it.name);
      this.chartOptions.xAxis.data = this.echartData.xAxisData;
      this.chartOptions.series = this.echartData.yAxisData;
      this.refreshChart();
    },
    refreshChart() {
      let myChart = this.echarts;
      if (!this.echarts) {
        myChart = echarts.init(this.$refs.echarts);
      }
      myChart.clear();
      myChart.setOption(this.chartOptions);
    }
  },
  watch: {
    echartData(newVal) {
      this.calcEcharts()
    }
  }
}
</script>
<style lang='scss' scoped>
.echarts {
  width: 100%;
  height: 400px;
}
</style>
